<div class="crumbs-container mb-1 position-sticky">
  @if (showPrevious) {
    <span>
      <div (click)="returnToPrevious()" class="crumb-return"><div>Return</div></div>
      <mat-icon class="crumb-icon">navigate_next</mat-icon>
    </span>
  }
  @for (crumb of breadCrumbs; track crumb; let i = $index) {
    @if (i>0) {
      <mat-icon class="crumb-icon">navigate_next</mat-icon>
    }
    @if (i<breadCrumbs.length-1) {
      <a [routerLink]="crumb.url" [queryParams]="crumb.params">{{crumb.label}}</a>
    } @else {
      <span>{{crumb.label}}</span>
    }
  }
</div>
